import { ConnectedProps, connect } from 'react-redux';
import React, { FC, useContext, useEffect } from 'react';
import { Pivot, PivotItem, PivotLinkSize } from '@fluentui/react';
import { Dialog } from '@eta/components';
import { useTranslation } from 'react-i18next';
import './ViewRepresentation.scss';
import Representation from './InviteUser/Representation';
import AccessBranches from './InviteUser/AccessBranches';
import { ReduxState } from '../../common/reducers';
import { RepresentationContext } from './InviteUser/Context/RepresentationContext';

export interface ViewRepresentationProps {
    hidden: boolean;
    onClose: () => void;
    representationID?: number;
}

const mapDispatchToProps = {};

const mapStateToProps = (state: ReduxState) => ({
    profile: state.profile.currentProfile,
    currentLanguage: state.reduxlanguage.language,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ViewRepresentation: FC<ViewRepresentationProps & PropsFromRedux> = (
    props: ViewRepresentationProps & PropsFromRedux
) => {
    const {
        onClose,
        hidden,
        profile,
        representationID,
        currentLanguage,
    } = props;
    const { t } = useTranslation(['common']);
    const { dispatch: dispatchInvitationRequest } = useContext(
        RepresentationContext
    );
    const representation = profile?.taxpayerRepresentations?.find(
        (x) => x.taxpayerRepresentationID === representationID
    );
    const en = !currentLanguage.isRtl;

   

    useEffect(() => {
        if (!hidden) {
            dispatchInvitationRequest({
                type: 'Reset',
            });
        }
    }, [hidden]);

    useEffect(() => {
        dispatchInvitationRequest({
            type: 'updateRepresentation',
            payload: {
                dateActivate: representation?.dateActivated,
                dateDeactivate: representation?.dateDeactivated,
                hasCustomRole: representation?.hasCustomRole,
                isAdministrator: representation?.isAdministrator,
                claims: representation?.taxpayerRepresentationClaims?.map(
                    (x) => x.claimCode ?? ''
                ),

                allBranches: representation?.allBranches,
                restrictedBranch:
                    representation?.taxpayerRepresentationBranches?.map(
                        (x) => x.branchNumber ?? -1
                    ),
            },
        });
    }, []);

    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={600}
            title={t('userDetails')}
            containerClassName="viewRepresentationDialog"
        >
            <div className="viewRepresentationPermission">
                <Pivot
                    className="representationTabs"
                    linkSize={PivotLinkSize.large}
                >
                    <PivotItem headerText={t('Representation')}>
                        <div className="content">
                            <Representation
                                readOnly
                                mode="View"
                                taxPayerName={
                                    en
                                        ? representation?.taxpayerNameEn
                                        : representation?.taxpayerNameAr
                                }
                            />
                        </div>
                    </PivotItem>
                    <PivotItem headerText={t('Branches')}>
                        <div className="content">
                            <AccessBranches readOnly />
                        </div>
                    </PivotItem>
                </Pivot>
            </div>
        </Dialog>
    );
};

export default connector(ViewRepresentation);
